<template>
  <div class="app header-fixed breadcrumb-fixed">
    <b-navbar v-if="$store.state.user" id="mainNavBar" toggleable="md" class="navbar-style fixed-top">
      <b-navbar-brand href="#" class="pr-5 text-logo pl-4">
        <router-link v-if="$store.state.userLastPlants.length >0 && this.$store.state.currentPlant" :to="{path: '/plant/'+ this.$store.state.currentPlant.id}"><img class="brandLogo" src="/img/logo_nube_new_white.png" width="142" height="auto" /></router-link>
        <router-link v-else :to="{path: '/home'}"><img class="brandLogo" src="/img/logo_nube_new_white.png" width="142" height="auto" /></router-link>
      </b-navbar-brand>

      <b-navbar-nav
        id="lastPlantsItem"
        v-if="this.$route.name!='AllPlants'"
        class="border-left border-right pr-5"
      >
        <b-nav-item
          v-if="$store.state.userLastPlants.length > 0 && this.$route.name!='NTOHome' && this.$route.name!='NTOUsers'"
          class="plant-menu"
          :disabled="this.loading"
          @click="mostraModalImpianti"
        >
          <span class="plant-menu-name">{{lastPlantName}}</span>
          <i v-if="this.loading==false" class="fa fa-chevron-down pull-right" style="color:white"></i>
          <br />
          <span class="plant-menu-desc">{{lastPlantAddress}}</span>
        </b-nav-item>
      </b-navbar-nav>

      <!-- settings plant-->
      <b-nav-text id="settings-item" v-if="this.$route.name!='AllPlants' && this.$route.name!='Home' && this.$route.name!='NTOHome' && $store.state.userLastPlants.length > 0  && this.$route.name!='NTOUsers'">
          <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right style="color:white; z-index: 2000">
            <template slot="button-content">
              <b-button variant="link" class="typo-label" style="color:white">  <!--@click="//openSettings()"-->
                <img id="settings-icon-img" src="img/config-white.svg" class="mr-1">
                <span id="settings-text" class="ml-2">{{$t("settings.title")}}</span>
              </b-button>
            </template>
            <b-dropdown-item @click="mostraPaginaGeneralPlant" class="p-1 typo-label">
              <i class="fas fa-info-circle" style="color:#333" aria-hidden="true"></i>
              {{$t("settings.general")}}</b-dropdown-item>
            <b-dropdown-item @click="mostraPaginaPlantUsers" class="p-1 typo-label">
              <i class="fas fa-users" style="color:#333" aria-hidden="true"></i>
              {{$t("settings.users")}}</b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item @click="mostraSelezionaLingue" class="p-1 typo-label">
              <i class="fas fa-globe" style="color:#333" aria-hidden="true"></i>
              {{$t("settings.select_language") + " (" + this.$i18n.locale.toUpperCase() + ")"}}
            </b-dropdown-item>
           </b-dropdown>
      </b-nav-text>

      <!-- notifiche-->
      <b-navbar-nav v-if="$store.state.userLastPlants.length >0" class="bell-item">
        <b-nav-text id="settings-icon" v-if="this.$route.name!='AllPlants' && this.$route.name!='Home' && this.$route.name!='NTOHome' && this.$route.name!='NTOUsers'">
          <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right style="color:white">
            <template slot="button-content">
              <b-button variant="link" class="typo-label" style="color:white">  <!--@click="//openSettings()"-->
                <img src="img/config-white.svg" class="mr-1">
              </b-button>
            </template>
            <b-dropdown-item @click="mostraPaginaGeneralPlant">{{$t("settings.general")}}</b-dropdown-item>
            <div class="dropdown-divider"></div>
            <b-dropdown-item @click="mostraPaginaPlantUsers">{{$t("settings.users")}}</b-dropdown-item>
           </b-dropdown>
        </b-nav-text>
        <b-nav-text id="bell" @click="mostraModalNotifiche">
          <i class="icon-bell"></i>
          <b-badge v-if="bellNotifiche> 0" pill variant="danger">{{bellNotifiche}}</b-badge>
        </b-nav-text>
      </b-navbar-nav>

      <!--avatar-->
      <b-nav-item-dropdown id="avatar-dropdown">
        <template v-slot:button-content>
          <b-button class="btn-avatar">
            <!--<span id="avatar-name" class="ml-2" style="color:white">{{getUserAvatar}}</span>-->
            <avatar
              :username="$store.getters.userName"
              background-color="#ffff"
              :size="40"
              :rounded="true"
              color="#04709c"
              class="ml-2 mt-1"
              style="display: inline-block"
            ></avatar>
          </b-button>
        </template>
        <b-dropdown-item @click="mostraPaginaUserProfile()" class="p-1 typo-label">
          <i class="fa fa-user" style="color:black"></i>
          {{$t("profile")}}
        </b-dropdown-item>
        <b-dropdown-item v-if="this.$store.state.user.usertype!='installer' && this.$store.state.user.usertype!='admin'" href="#" @click="mostraPaginaBecomeInstaller()" class="p-1 typo-label">
          <i class="fa fa-superpowers" style="color:#009DE0"></i>
          <span style="color:#009DE0">{{$t("becomeInstaller")}}</span>
        </b-dropdown-item>
        <b-dropdown-item href="#" @click="about" class="p-1 typo-label">
          <i class="fa fa-info-circle" style="color:black"></i>About
        </b-dropdown-item>
        <b-dropdown-item href="#" @click="logout" class="p-1 typo-label">
          <i class="fa fa-sign-out" style="color:black"></i>
          {{$t("signout")}}
        </b-dropdown-item>
        <hr />
        <b-dropdown-item href="#" @click="mostraPaginaSupporto()" class="p-1 typo-label">
          <i class="fa fa-question-circle" style="color:black"></i>
          {{$t("support")}}
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar>

    <div class="pagecontent mb-5">
      <router-view v-if="this.$router.currentRoute.name.toLowerCase()=='ambienti' || this.$router.currentRoute.name.toLowerCase()=='planimetrie'" :key="$route.path"></router-view>
      <router-view v-else></router-view>
    </div>

    <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
      <TheFooter class="fixed-bottom">
        <!--footer-->
        <b-row class="typo-footer">
          <b-col cols="8">
            <div class="float-left">
              <span
                class="ml-2"
              >© Beghelli S.p.A. - Via Mozzeghine 13/15 - loc. Monteveglio 40053 Valsamoggia, Bologna(IT)- P.IVA 00666341201</span>
            </div>
          </b-col>
          <b-col cols="4">
            <div class="btn-group float-right">
              <a
                :href="$t('link.privacy_policy_site')"
                variant="link"
                class="typo-footer-link mr-2"
                 target="_blank"
              >{{$t("privacy_policy")}}</a>
              |
              <a
                :href="$t('link.cookie_policy')"
                variant="link"
                class="typo-footer-link ml-2 mr-2"
                 target="_blank"
              >{{$t("cookie_policy")}}</a>
              <!-- |
              <b-button
                v-b-modal.modal-supporto
                variant="link"
                class="typo-footer-link ml-2"
              >{{$t("support")}}</b-button>-->
            </div>
          </b-col>
        </b-row>
      </TheFooter>
    </hide-at>

    <!-- Settings Profile -->
    <b-modal
      ref="modal"
      id="modal-settingsProfile"
      :saveSubmit="saveSubmit"
      :hide-footer="true"
      :title="$t('user_modal.edit_title')"
      @show="chargeCurrentUserSettings"
      size="xl"
    >
     <b-row>
      <!--- User details --->
      <b-col xl="4" lg="4" class="mt-3 mapcol">
      <b-card class="radius-card h-100">

      <b-form-group>
          <b-row>
            <b-col cols="12">
                <span class="typo-label"><b>{{$t("user_modal.edit_subtitle")}}</b></span>
            </b-col>
            <b-col sm="6" class="mt-3">
                <b-form-group>
                    <label for="label-user-name" class="ml-2">{{$t("user_modal.label_name")}}</label>
                    <b-form-input v-model="userName" type="text" :state="validation_userName" id="placeholder-user-name" :placeholder="$t('user_modal.placeholder_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="6" class="mt-3">
                <b-form-group>
                    <label for="label-user-surname" class="ml-2">{{$t("user_modal.label_surname")}}</label>
                    <b-form-input v-model="userSurname" type="text" :state="validation_userSurname" id="placeholder-user-surname" :placeholder="$t('user_modal.placeholder_surname')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userSurname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>
      </b-form-group>

      <b-form-group>
          <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label for="label-user-business-name" class="ml-2">{{$t("user_modal.label_business_name")}}</label>
                    <b-form-input v-model="userbusinessName" type="text" :state="validation_userbusinessName" id="placeholder-user-business-name" :placeholder="$t('user_modal.placeholder_business_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
                <b-form-group>
                    <label for="label-user-piva" class="ml-2">{{$t("user_modal.label_piva")}}</label>
                    <b-form-input v-model="userPiva" type="text" :state="validation_userPiva" id="placeholder-user-piva" :placeholder="$t('user_modal.placeholder_piva')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label for="label-user-phone" class="ml-2">{{$t("user_modal.label_phone")}}</label>
                    <b-form-input v-model="userPhone" type="text" :state="validation_userPhone" id="placeholder-user-phone" :placeholder="$t('user_modal.placeholder_phone')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPhone">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
          </b-row>
      </b-form-group>

      <b-form-group>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-user-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                <b-form-input v-model="userStreet" type="text" :state="validation_userStreet" id="placeholder-user-street" :placeholder="$t('user_modal.placeholder_street')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-user-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                <b-form-input v-model="userNumber" type="text" :state="validation_userNumber" id="placeholder-user-number" :placeholder="$t('user_modal.placeholder_number')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
      </b-form-group>

          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-user-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                <b-form-input v-model="userCity" type="text" :state="validation_userCity" id="placeholder-user-city" :placeholder="$t('user_modal.placeholder_city')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-user-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                <b-form-input v-model="userCap" type="text" :state="validation_userCap" id="placeholder-user-cap" :placeholder="$t('user_modal.placeholder_cap')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>


            <b-form-group>
            <b-row>
            <b-col sm="8">
              <b-form-group>
                <label for="label-user-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                <b-form-input v-model="userProv" type="text" :state="validation_userProv" id="placeholder-user-prov" :placeholder="$t('user_modal.placeholder_prov')"></b-form-input>
                <b-form-invalid-feedback :state="validation_userProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="label-user-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                <b-form-select v-model="userCountry" :country="country">
                    <option :value="null">{{$t("user_modal.placeholder_country")}}</option>
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Åland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia, Plurinational State of</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">Congo, the Democratic Republic of the</option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curaçao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">Heard Island and McDonald Islands</option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, Democratic People's Republic of</option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Réunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthélemy</option>
                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (French part)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Dutch part)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">United States Minor Outlying Islands</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                </b-form-select>
              </b-form-group>
                </b-col>
            </b-row>
          </b-form-group>

          </b-card>
        </b-col>


       <!--- Marketing consent --->
       <b-col xl="4" lg="4" class="mt-3 mapcol">
           <b-card class="radius-card h-100">
              <span class="typo-label"><b>{{$t("user_modal.edit_marketing")}}</b></span>
              <b-row class="typo-label mt-4 ml-1">
                    <b-col cols="1">
                      <input type="checkbox" id="chk-marketing" v-model="chk_marketing">
                    </b-col>
                    <b-col cols="11">
                      <label for="checkbox" class="ml-1">{{$t("check_marketing")}}<a href="" class="ml-1">(Approfondisci)</a></label>
                    </b-col>
                  </b-row>

                  <b-row class="typo-label mt-4 ml-1">
                    <b-col cols="1">
                      <input type="checkbox" id="chk-profile" v-model="chk_profiling">
                    </b-col>
                    <b-col cols="11">
                      <label for="checkbox" class="ml-1">{{$t("check_profiling")}}<a href="" class="ml-1">(Approfondisci)</a></label>
                    </b-col>
                  </b-row>

                  <b-row class="typo-label mt-4 ml-1">
                    <b-col cols="1">
                      <input type="checkbox" id="chk-comunication" v-model="chk_thirdParts">
                    </b-col>
                    <b-col cols="11">
                      <label for="checkbox" class="ml-1">{{$t("check_third_parts")}}<a href="" class="ml-1">(Approfondisci)</a></label>
                    </b-col>
                  </b-row>
           </b-card>
       </b-col>

       <!--- Manage plant collaborator and client  --->
       <b-col xl="4" lg="4" class="mt-3 mapcol">
           <b-card class="radius-card h-100">
              <span class="typo-label"><b>{{$t("user_modal.edit_collaborator")}}</b></span>
           </b-card>
       </b-col>

     </b-row>
    </b-modal>

    <!-- Settings plant -->
    <b-modal
      ref="modal"
      id="modal-settingsPlant"
      :saveSubmit="saveSubmit"
      :hide-footer="true"
      :title="$t('edit_plant_modal.title')"
      @show="chargeCurrentSettings"
      size="xl"
    >
      <b-row>
        <!--- Plant Google Map --->
        <b-col xl="4" lg="4" class="mt-3 mapcol">
          <div class="embed-responsive embed-responsive-4by3 radius-card h-100">
            <plant-map />
          </div>
        </b-col>

        <!--- Edit plant details --->
        <b-col cols="4">
          <b-card class="text-widget radius-card h-100">

            <b-form-group>
              <label for="label-plant-name">{{$t("edit_plant_modal.label_plant_name")}}</label>
              <b-form-input
                v-model="plantName"
                type="text"
                id="placeholder-plant-name"
                :placeholder="$t('new_plant_modal.placeholder_plant_name')"
                :state="validation_plantName">
              </b-form-input>
              <b-form-invalid-feedback
                :state="validation_plantName"
              >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label for="label-plant-street">{{$t("edit_plant_modal.label_plant_street")}}</label>
                    <b-form-input
                      v-model="plantStreet"
                      type="text"
                      :state="validation_plantStreet"
                      id="placeholder-plant-street"
                      :placeholder="$t('edit_plant_modal.placeholder_plant_street')"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      :state="validation_plantStreet"
                    >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="label-plant-number">{{$t("edit_plant_modal.label_plant_number")}}</label>
                    <b-form-input
                      v-model="plantNumber"
                      type="text"
                      :state="validation_plantNumber"
                      id="placeholder-plant-number"
                      :placeholder="$t('edit_plant_modal.placeholder_plant_number')"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      :state="validation_plantNumber"
                    >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
            <b-row>
              <b-col sm="8">
                <b-form-group>
                  <label for="label-plant-city">{{$t("edit_plant_modal.label_plant_city")}}</label>
                  <b-form-input
                    v-model="plantCity"
                    type="text"
                    :state="validation_plantCity"
                    id="placeholder-plant-city"
                    :placeholder="$t('edit_plant_modal.placeholder_plant_city')"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="validation_plantCity"
                  >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="label-plant-cap">{{$t("edit_plant_modal.label_plant_cap")}}</label>
                  <b-form-input
                    v-model="plantCap"
                    type="text"
                    :state="validation_plantCap"
                    id="placeholder-plant-cap"
                    :placeholder="$t('edit_plant_modal.placeholder_plant_cap')"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    :state="validation_plantCap"
                  >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label for="label-plant-prov">{{$t("edit_plant_modal.label_plant_prov")}}</label>
                    <b-form-input
                      v-model="plantProv"
                      type="text"
                      :state="validation_plantProv"
                      id="placeholder-plant-prov"
                      :placeholder="$t('edit_plant_modal.placeholder_plant_prov')"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      :state="validation_plantProv"
                    >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="label-plant-country">{{$t("edit_plant_modal.label_plant_country")}}</label>
                    <b-form-select v-model="plantCountry" :country="country">
                      <option :value="null">{{$t("edit_plant_modal.placeholder_plant_country")}}</option>
                      <option value="AF">Afghanistan</option>
                      <option value="AX">Åland Islands</option>
                      <option value="AL">Albania</option>
                      <option value="DZ">Algeria</option>
                      <option value="AS">American Samoa</option>
                      <option value="AD">Andorra</option>
                      <option value="AO">Angola</option>
                      <option value="AI">Anguilla</option>
                      <option value="AQ">Antarctica</option>
                      <option value="AG">Antigua and Barbuda</option>
                      <option value="AR">Argentina</option>
                      <option value="AM">Armenia</option>
                      <option value="AW">Aruba</option>
                      <option value="AU">Australia</option>
                      <option value="AT">Austria</option>
                      <option value="AZ">Azerbaijan</option>
                      <option value="BS">Bahamas</option>
                      <option value="BH">Bahrain</option>
                      <option value="BD">Bangladesh</option>
                      <option value="BB">Barbados</option>
                      <option value="BY">Belarus</option>
                      <option value="BE">Belgium</option>
                      <option value="BZ">Belize</option>
                      <option value="BJ">Benin</option>
                      <option value="BM">Bermuda</option>
                      <option value="BT">Bhutan</option>
                      <option value="BO">Bolivia, Plurinational State of</option>
                      <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                      <option value="BA">Bosnia and Herzegovina</option>
                      <option value="BW">Botswana</option>
                      <option value="BV">Bouvet Island</option>
                      <option value="BR">Brazil</option>
                      <option value="IO">British Indian Ocean Territory</option>
                      <option value="BN">Brunei Darussalam</option>
                      <option value="BG">Bulgaria</option>
                      <option value="BF">Burkina Faso</option>
                      <option value="BI">Burundi</option>
                      <option value="KH">Cambodia</option>
                      <option value="CM">Cameroon</option>
                      <option value="CA">Canada</option>
                      <option value="CV">Cape Verde</option>
                      <option value="KY">Cayman Islands</option>
                      <option value="CF">Central African Republic</option>
                      <option value="TD">Chad</option>
                      <option value="CL">Chile</option>
                      <option value="CN">China</option>
                      <option value="CX">Christmas Island</option>
                      <option value="CC">Cocos (Keeling) Islands</option>
                      <option value="CO">Colombia</option>
                      <option value="KM">Comoros</option>
                      <option value="CG">Congo</option>
                      <option value="CD">Congo, the Democratic Republic of the</option>
                      <option value="CK">Cook Islands</option>
                      <option value="CR">Costa Rica</option>
                      <option value="CI">Côte d'Ivoire</option>
                      <option value="HR">Croatia</option>
                      <option value="CU">Cuba</option>
                      <option value="CW">Curaçao</option>
                      <option value="CY">Cyprus</option>
                      <option value="CZ">Czech Republic</option>
                      <option value="DK">Denmark</option>
                      <option value="DJ">Djibouti</option>
                      <option value="DM">Dominica</option>
                      <option value="DO">Dominican Republic</option>
                      <option value="EC">Ecuador</option>
                      <option value="EG">Egypt</option>
                      <option value="SV">El Salvador</option>
                      <option value="GQ">Equatorial Guinea</option>
                      <option value="ER">Eritrea</option>
                      <option value="EE">Estonia</option>
                      <option value="ET">Ethiopia</option>
                      <option value="FK">Falkland Islands (Malvinas)</option>
                      <option value="FO">Faroe Islands</option>
                      <option value="FJ">Fiji</option>
                      <option value="FI">Finland</option>
                      <option value="FR">France</option>
                      <option value="GF">French Guiana</option>
                      <option value="PF">French Polynesia</option>
                      <option value="TF">French Southern Territories</option>
                      <option value="GA">Gabon</option>
                      <option value="GM">Gambia</option>
                      <option value="GE">Georgia</option>
                      <option value="DE">Germany</option>
                      <option value="GH">Ghana</option>
                      <option value="GI">Gibraltar</option>
                      <option value="GR">Greece</option>
                      <option value="GL">Greenland</option>
                      <option value="GD">Grenada</option>
                      <option value="GP">Guadeloupe</option>
                      <option value="GU">Guam</option>
                      <option value="GT">Guatemala</option>
                      <option value="GG">Guernsey</option>
                      <option value="GN">Guinea</option>
                      <option value="GW">Guinea-Bissau</option>
                      <option value="GY">Guyana</option>
                      <option value="HT">Haiti</option>
                      <option value="HM">Heard Island and McDonald Islands</option>
                      <option value="VA">Holy See (Vatican City State)</option>
                      <option value="HN">Honduras</option>
                      <option value="HK">Hong Kong</option>
                      <option value="HU">Hungary</option>
                      <option value="IS">Iceland</option>
                      <option value="IN">India</option>
                      <option value="ID">Indonesia</option>
                      <option value="IR">Iran, Islamic Republic of</option>
                      <option value="IQ">Iraq</option>
                      <option value="IE">Ireland</option>
                      <option value="IM">Isle of Man</option>
                      <option value="IL">Israel</option>
                      <option value="IT">Italy</option>
                      <option value="JM">Jamaica</option>
                      <option value="JP">Japan</option>
                      <option value="JE">Jersey</option>
                      <option value="JO">Jordan</option>
                      <option value="KZ">Kazakhstan</option>
                      <option value="KE">Kenya</option>
                      <option value="KI">Kiribati</option>
                      <option value="KP">Korea, Democratic People's Republic of</option>
                      <option value="KR">Korea, Republic of</option>
                      <option value="KW">Kuwait</option>
                      <option value="KG">Kyrgyzstan</option>
                      <option value="LA">Lao People's Democratic Republic</option>
                      <option value="LV">Latvia</option>
                      <option value="LB">Lebanon</option>
                      <option value="LS">Lesotho</option>
                      <option value="LR">Liberia</option>
                      <option value="LY">Libya</option>
                      <option value="LI">Liechtenstein</option>
                      <option value="LT">Lithuania</option>
                      <option value="LU">Luxembourg</option>
                      <option value="MO">Macao</option>
                      <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                      <option value="MG">Madagascar</option>
                      <option value="MW">Malawi</option>
                      <option value="MY">Malaysia</option>
                      <option value="MV">Maldives</option>
                      <option value="ML">Mali</option>
                      <option value="MT">Malta</option>
                      <option value="MH">Marshall Islands</option>
                      <option value="MQ">Martinique</option>
                      <option value="MR">Mauritania</option>
                      <option value="MU">Mauritius</option>
                      <option value="YT">Mayotte</option>
                      <option value="MX">Mexico</option>
                      <option value="FM">Micronesia, Federated States of</option>
                      <option value="MD">Moldova, Republic of</option>
                      <option value="MC">Monaco</option>
                      <option value="MN">Mongolia</option>
                      <option value="ME">Montenegro</option>
                      <option value="MS">Montserrat</option>
                      <option value="MA">Morocco</option>
                      <option value="MZ">Mozambique</option>
                      <option value="MM">Myanmar</option>
                      <option value="NA">Namibia</option>
                      <option value="NR">Nauru</option>
                      <option value="NP">Nepal</option>
                      <option value="NL">Netherlands</option>
                      <option value="NC">New Caledonia</option>
                      <option value="NZ">New Zealand</option>
                      <option value="NI">Nicaragua</option>
                      <option value="NE">Niger</option>
                      <option value="NG">Nigeria</option>
                      <option value="NU">Niue</option>
                      <option value="NF">Norfolk Island</option>
                      <option value="MP">Northern Mariana Islands</option>
                      <option value="NO">Norway</option>
                      <option value="OM">Oman</option>
                      <option value="PK">Pakistan</option>
                      <option value="PW">Palau</option>
                      <option value="PS">Palestinian Territory, Occupied</option>
                      <option value="PA">Panama</option>
                      <option value="PG">Papua New Guinea</option>
                      <option value="PY">Paraguay</option>
                      <option value="PE">Peru</option>
                      <option value="PH">Philippines</option>
                      <option value="PN">Pitcairn</option>
                      <option value="PL">Poland</option>
                      <option value="PT">Portugal</option>
                      <option value="PR">Puerto Rico</option>
                      <option value="QA">Qatar</option>
                      <option value="RE">Réunion</option>
                      <option value="RO">Romania</option>
                      <option value="RU">Russian Federation</option>
                      <option value="RW">Rwanda</option>
                      <option value="BL">Saint Barthélemy</option>
                      <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                      <option value="KN">Saint Kitts and Nevis</option>
                      <option value="LC">Saint Lucia</option>
                      <option value="MF">Saint Martin (French part)</option>
                      <option value="PM">Saint Pierre and Miquelon</option>
                      <option value="VC">Saint Vincent and the Grenadines</option>
                      <option value="WS">Samoa</option>
                      <option value="SM">San Marino</option>
                      <option value="ST">Sao Tome and Principe</option>
                      <option value="SA">Saudi Arabia</option>
                      <option value="SN">Senegal</option>
                      <option value="RS">Serbia</option>
                      <option value="SC">Seychelles</option>
                      <option value="SL">Sierra Leone</option>
                      <option value="SG">Singapore</option>
                      <option value="SX">Sint Maarten (Dutch part)</option>
                      <option value="SK">Slovakia</option>
                      <option value="SI">Slovenia</option>
                      <option value="SB">Solomon Islands</option>
                      <option value="SO">Somalia</option>
                      <option value="ZA">South Africa</option>
                      <option value="GS">South Georgia and the South Sandwich Islands</option>
                      <option value="SS">South Sudan</option>
                      <option value="ES">Spain</option>
                      <option value="LK">Sri Lanka</option>
                      <option value="SD">Sudan</option>
                      <option value="SR">Suriname</option>
                      <option value="SJ">Svalbard and Jan Mayen</option>
                      <option value="SZ">Swaziland</option>
                      <option value="SE">Sweden</option>
                      <option value="CH">Switzerland</option>
                      <option value="SY">Syrian Arab Republic</option>
                      <option value="TW">Taiwan, Province of China</option>
                      <option value="TJ">Tajikistan</option>
                      <option value="TZ">Tanzania, United Republic of</option>
                      <option value="TH">Thailand</option>
                      <option value="TL">Timor-Leste</option>
                      <option value="TG">Togo</option>
                      <option value="TK">Tokelau</option>
                      <option value="TO">Tonga</option>
                      <option value="TT">Trinidad and Tobago</option>
                      <option value="TN">Tunisia</option>
                      <option value="TR">Turkey</option>
                      <option value="TM">Turkmenistan</option>
                      <option value="TC">Turks and Caicos Islands</option>
                      <option value="TV">Tuvalu</option>
                      <option value="UG">Uganda</option>
                      <option value="UA">Ukraine</option>
                      <option value="AE">United Arab Emirates</option>
                      <option value="GB">United Kingdom</option>
                      <option value="US">United States</option>
                      <option value="UM">United States Minor Outlying Islands</option>
                      <option value="UY">Uruguay</option>
                      <option value="UZ">Uzbekistan</option>
                      <option value="VU">Vanuatu</option>
                      <option value="VE">Venezuela, Bolivarian Republic of</option>
                      <option value="VN">Viet Nam</option>
                      <option value="VG">Virgin Islands, British</option>
                      <option value="VI">Virgin Islands, U.S.</option>
                      <option value="WF">Wallis and Futuna</option>
                      <option value="EH">Western Sahara</option>
                      <option value="YE">Yemen</option>
                      <option value="ZM">Zambia</option>
                      <option value="ZW">Zimbabwe</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button
                    @click="handleOk()"
                    variant="info"
                    style="color:white; background-color:#009DE0"
                    class="mt-4 mr-3 float-right"
                  >{{$t("edit_plant_modal.button_plant_save")}}</b-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-card>
        </b-col>

        <!-- Altri dati impianto -->
        <b-col cols="4" v-if="plantDetails != null">
          <b-row>
            <b-col cols="auto">
              <b-card>
                <label>{{$t("edit_plant_modal.label_plant_type")}}:</label>
                <span> <strong> {{$t(plantDetails.plant_type)}} <i v-if="isPro" class="fa fa-check fa-2x" style="color: #009900" /></strong></span>
                <div v-if="isPro">
                  <label>Chiave di attivazione: <strong >{{plantDetails.pro_code[plantDetails.pro_code.length-1].code}}</strong></label>
                </div>
                <div v-else>
                  <b-button v-b-toggle.pro-code-collapse variant="primary">Passa a PRO!</b-button>
                  <b-collapse id="pro-code-collapse" class="mt-4">
                    <p>Passa a PRO per attivare tutte le funzionalità del tuo impianto NuBe.</p>
                    <p>Acquista un codice di attivazione PRO andando sullo store Beghelli o contattando il nostro Call Center. Inseriscilo nello spazio sottostante ed attiva subito le funzionalità PROFESSIONAL!</p>
                    <b-form @submit="abilitaPro">
                      <b-form-group label="Codice Attivazione PRO" label-for="proCode" description="Inserisci il codice a 16 cifre ricevuto">
                        <b-form-input id="proCode" :state="codeState" v-model="codicePro" type="number" required placeholder="Codice Attivazione PRO" ></b-form-input>
                      </b-form-group>
                      <b-button type="submit" :disabled="submitCodeDisabled" variant="primary">ATTIVA!</b-button> <span v-if="updatingPro"><i class="fa fa-spin fa-spinner" /> Validazione in corso...</span>
                    </b-form>
                  </b-collapse>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="$store.getters.userRole == 'installer'">
            <b-col cols="auto">
              <b-card title="Collaboratori">
                <p v-if="collaboratori == null">Nessun collaboratore presente<br/>Solo tu hai accesso a questo impianto come Installatore.</p>
                <div v-else>
                  <b-button v-for="(coll,index) in collaboratori" :key="index" variant="primary" size="small" class="btn-pill mb-1 mr-1" @click="rimuoviCollab(coll.userid, coll.nome)">{{coll.nome}} <i class="fa fa-close"></i></b-button>
                </div>
                <p>Puoi invitare altri collaboratori abilitati a gestire l'impianto inserendo un indirizzo email qui sotto.</p>
                <div style="display:flex; margin-top: 1em">
                <b-form-input id="txtEmailCollab" v-model="emailCollab" type="email" required placeholder="Email collaboratore" style="flex-grow: 1; width: auto; margin-right: 0.5em"></b-form-input>
                  <b-button v-if="!invitingCollab" size="sm" variant="primary" @click="invitaCollab">Invita Collaboratore</b-button>
                  <div v-else style="width: 40px; margin-left: 8px"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="$store.getters.userRole == 'installer'">
            <b-col cols="auto">
              <b-card title="Proprietario">
                <div v-if="clienteImpianto == null">
                  <p>Nessun utente invitato come proprietario dell'impianto.<br/>Puoi invitare il cliente ad accedere alla visualizzazione dell'impianto inserendo l'email qui sotto.</p>
                  <div style="display:flex; margin-top: 1em">
                  <b-form-input id="txtEmailCliente" v-model="emailCliente" type="email" required placeholder="Email proprietario" style="flex-grow: 1; width: auto; margin-right: 0.5em"></b-form-input>
                    <b-button v-if="!invitingCliente" size="sm" variant="primary" @click="invitaCliente">Invita Proprietario</b-button>
                    <div v-else style="width: 40px; margin-left: 8px"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
                  </div>
                </div>
                <div v-else>
                    <p>Cliente intestatario impianto:<br/><strong>{{clienteImpianto.nome}}</strong></p>

                </div>

              </b-card>
            </b-col>
          </b-row>

          <b-row v-if="$store.getters.userRole == 'client' || $store.getters.userRole == 'delegate'">
            <b-col cols="auto">
              <b-card title="Proprietario">

                <p><strong>{{clienteImpianto.nome}}</strong></p>
                <div v-if="$store.getters.userRole == 'client'">
                  <h4>Delegati</h4>
                  <p v-if="delegati == null">Nessun delegato presente</p>
                  <div v-else>
                    <b-button v-for="(coll,index) in delegati" :key="index" variant="primary" size="small" class="btn-pill mb-1 mr-1" @click="rimuoviDelegato(coll.userid, coll.nome)">{{coll.nome}} <i class="fa fa-close"></i></b-button>
                  </div>
                  <p>Puoi invitare altri utenti abilitati a visualizzare l'impianto inserendo un indirizzo email qui sotto.</p>
                  <div style="display:flex; margin-top: 1em">
                    <b-form-input id="txtEmailDelegato" v-model="emailDelegato" type="email" required placeholder="Email delegato" style="flex-grow: 1; width: auto; margin-right: 0.5em"></b-form-input>
                    <b-button v-if="!invitingDelegato" size="sm" variant="primary" @click="invitaDelegato">Invita Delegato</b-button>
                    <div v-else style="width: 40px; margin-left: 8px"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>


        </b-col>
      </b-row>
    </b-modal>

    <!-- About -->
    <b-modal ref="about-modal" id="modal-about" centered title="About" hide-footer>
        <div class="p-3">
          <h6>NuBe Beghelli Cloud</h6>
          <h6></h6>
          <h6><b> {{ $t('version')}}:</b> 03.48 </h6>
          <h6><b> {{ $t('last_update')}}:</b> 30/04/2026 </h6>
          <b-button variant="primary" v-b-modal.modal-release-notes class="mt-3">
            {{ $t('release_notes') }}
          </b-button>
        </div>
    </b-modal>

    <!-- Modal Release Notes -->
    <b-modal id="modal-release-notes" title="Release Notes" size="lg" scrollable ok-only>
      <div>
        <h6>Version 03.48 - 30/04/2026</h6>
        <ul>
          <li> {{ $t("release0348.new_feat_planimetry") }} </li>
          <li> {{ $t("release0348.new_feat_replace") }} </li>
        </ul>
      </div>
      <div>
        <h6>Version 03.47 - 26/03/2026</h6>
        <ul>
          <li> {{ $t("release0347.bug_fix_loading") }} </li>
          <li> {{ $t("release0347.bug_fix_batt") }} </li>
          <li> {{ $t("release0347.new_feat_error") }} </li>
        </ul>
      </div>
      <div>
        <h6>Version 03.46 - 25/02/2026</h6>
        <ul>
          <li> {{ $t("release0346.bug_fix") }} </li>
        </ul>
      </div>
      <div>
        <h6>Version 03.45 - 24/02/2026</h6>
        <ul>
          <li> {{ $t("release0345.new_feat_search") }} </li>
          <li> {{ $t("release0345.new_feat_planimetry") }} </li>
        </ul>
      </div>
      <div>
        <h6>Version 03.44 - 20/01/2026</h6>
        <ul>
          <li> {{ $t("release0344.new_feat_bluetooth_report") }} </li>
        </ul>
      </div>
      <div>
        <h6>Version 03.43 - 16/01/2026</h6>
        <ul>
          <li> {{ $t("release0343.new_feat_bluetooth_zones") }} </li>
          <li> {{ $t("release0343.new_feat_mains_report") }} </li>
        </ul>
      </div>
      <div>
        <h6>Version 03.42 - 19/12/2025</h6>
        <ul>
          <li> {{ $t("release0342.bug_fix_diacritics") }} </li>
          <li> {{ $t("release0342.bug_fix_lamp_desc") }} </li>
          <li> {{ $t("release0342.new_feat_release_notes") }} </li>
        </ul>
      </div>
    </b-modal>

    <!-- Last plants -->
    <b-modal ref="plants-modal" id="modal-lastPlants" size="lg" @hide="filtroImpianto = ''">
      <template v-slot:modal-header="{ }">
        <b-form-input
          autofocus
          v-model="filtroImpianto"
          :placeholder="$t('placeholder_search_plant')"
          class="mr-4"
        ></b-form-input>
        <a href="#" class="searchButton">
          <i class="fa fa-search"></i>
        </a>
      </template>
      <template v-slot:modal-footer="{}">
        <b-row class="h-100 w-100">
          <b-col sm="3" style="padding-left: 0px;">
            <add-plant />
          </b-col>
          <b-col sm="9" class="text-right mt-2">
            <b-button v-if="$store.getters.user.usertype == 'admin'" class="typo-label; mr-4" variant="link" @click="mostraMappaAdmin">{{$t("allplants_installer")}}</b-button>
            <b-button class="typo-label" variant="link" @click="mostraTutti">{{$t("allplants")}}</b-button>
            <!--<b-button v-if="$store.getters.userRole == 'admin'" class="typo-label" variant="link" @click="mostraMappaAdmin">General Map</b-button>-->
          </b-col>
        </b-row>
      </template>
      <div v-if="filtLastPlants && filtLastPlants.length > 0 && filtLastPlants[0]">
        <b-row v-for="(plant,index) in filtLastPlants" :key="`${index}-${plant.id}`">
          <b-col>
            <div
              :class="['plantList', index == 0 ? 'selected' : '']"
              @click="selectPlant(plant.id,index)"
            >
              <h5>{{plant.plantname}}</h5>
              <span>{{plant.address.street}} {{plant.address.housenumber}} - {{plant.address.city}} ({{plant.address.prov}})</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


    <!-- Notifiche -->
    <b-modal ref="notifiche-modal" class="overflow-auto" id="modal-notifiche" size="md" :hide-footer="true">
      <template v-slot:modal-header="{ }">
        <label class="typo-title mt-3 ml-3"><b>{{bellNotifiche}}</b> {{$t('notifications.title')}}
         </label>
      </template>
      <b-row v-for="(notifica,index) in this.notificheAllPlants" :key="`${index}-${notifica.id}`">
        <b-col>
          <b-card class="notifiche" v-bind:class="{notificaerror:notifica.type=='error'}">
            <div>
              <div v-if="notifica.type=='warning'" class="typo-label" style="color:#edd112"><b>{{$t('notifications.warning_title', {cuid:notifica.cuid,cuname:notifica.cuname})}}</b></div>
              <div v-if="notifica.type=='error'" class="typo-label" style="color:red"><b>{{$t('notifications.error_title', {cuid:notifica.cuid,cuname:notifica.cuname})}}</b></div>

              <div v-if="notifica.type=='error' && notifica.numerrors==1" class="typo-label mt-1">
                <div>{{$t('notifications.error', {number:notifica.numerrors,cuid:notifica.cuid,cuname:notifica.cuname})}}</div>
                <div>{{$t('notifications.plant')}}: <b-button class="linkplant ml-1" variant="link" @click="openPlant(notifica.plant)"> {{notifica.plant.plantname}}</b-button></div>
              </div>

              <div v-if="notifica.type=='error' && notifica.numerrors>1" class="typo-label mt-1" >
                <div>{{$t('notifications.errors', {number:notifica.numerrors,cuid:notifica.cuid,cuname:notifica.cuname})}}</div>
                <div>{{$t('notifications.plant')}}: <b-button class="linkplant ml-1" variant="link" @click="openPlant(notifica.plant)"> {{notifica.plant.plantname}}</b-button></div>
              </div>

              <div v-if="notifica.type=='warning'" class="typo-label mt-1" >
                <div>{{$t('notifications.warning', {number:notifica.numerrors,cuid:notifica.cuid,cuname:notifica.cuname})}}</div>
                <div>{{$t('notifications.plant')}}: <b-button class="linkplant ml-1" variant="link" @click="openPlant(notifica.plant)"> {{notifica.plant.plantname}}</b-button></div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>


    <!-- Profilo utente -->
    <b-modal
      id="modal-profile"
      :title="$t('lamp_details_modal.title')"
      :ok-only="true"
      ok-title="Chiudi"
    ></b-modal>

      <!-- Select Language -->
      <b-modal
          ref="modal-language"
          id="modal-language"
          centered
          :title="$t('settings.select_language')"
          @ok="saveLocale">
          <div class="p-3">
            <b-form-group>
              <b-form-select
                  v-model="linguaSelected"
                  :options="optionLang"
                  class="w-100"
                  :aria-label="$t('settings.select_language')">
              </b-form-select>
            </b-form-group>
          </div>
    </b-modal>
    <!-- :options="Object.keys(this.$i18n.messages)" -->


  </div>
</template>

<script>
import Avatar from "vue-avatar";
import nav from "@/_mainnav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
import DefaultHeaderDropdownNotif from "./DefaultHeaderDropdownNotif";
import HeaderAccount from "./HeaderAccount";
import DefaultHeaderDropdownMssgs from "./DefaultHeaderDropdownMssgs";
import DefaultHeaderDropdownTasks from "./DefaultHeaderDropdownTasks";
import AddPlant from "@/components/AddPlant";
import { showAt, hideAt } from "vue-breakpoints";
import router from "../router/approuter";
import PlantMap from "@/components/PlantMap";

import { Auth } from "aws-amplify";
import axios from "axios";
import { mapState } from "vuex";


export default {
  name: "MainContainer",
  components: {
    Avatar,
    AddPlant,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    HeaderAccount,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    showAt,
    hideAt,
    PlantMap
  },
  data() {
    return {
      emailDelegato: '',
      invitingDelegato: false,
      emailCliente: '',
      invitingCliente: false,
      emailCollab: '',
      invitingCollab: false,
      updatingPro: false,
      codicePro: "",
      filtroImpianto: "",
      nav: nav.items,
      userName: '',
      userSurname:'',
      userbusinessName:'',
      userPiva:'',
      userPhone:'',
      userStreet:'',
      userNumber:'',
      userCity:'',
      userCap:'',
      userProv:'',
      userCountry:'IT',
      chk_marketing:false,
      chk_profiling:false,
      chk_thirdParts:false,
      plantId:"",
      plantName: "",
      plantStreet: "",
      plantNumber: "",
      plantCity: "",
      plantCap: "",
      plantProv: "",
      plantCountry: "IT",
      country: null,
      saveSubmit: "false",
      saveUser:"false",
      accessToken: "pk.eyJ1IjoiYmVnaGVsbGlkZXYiLCJhIjoiY2s4dHdzMTB1MDN2YjNwbXd3aTBjZ25payJ9.bGime-PtFWnugxAAL1G3yQ",
      apiUrl: "https://api.mapbox.com/geocoding/v5/mapbox.places/",
      //notificheAllPlants:[],
      optionLang: [
        { value: "it", text: "Italiano" },
        { value: "en", text: "English" },
        { value: "fr", text: "Français" },
        { value: "de", text: "Deutsch" },
        { value: "es", text: "Español" },
        { value: "no", text: "Norsk" },
        { value: "cs", text: "Čeština" },
        { value: "pt", text: "Português" },
        { value: "pl", text: "Polski" },
      //   { value: "ro", text: "Română" },
      //   { value: "ru", text: "Русский" },
      //   { value: "tr", text: "Türkçe" },
      //   { value: "zh", text: "中文" }
      ],
      linguaSelected: this.$i18n.locale,
    };
  },
  mounted() {
    const self = this;
    this.$root.$on('openSettingsEvent', () => {
        self.openSettings();
    });
  },
  computed: {
    ...mapState(['commandResponse','error','loading']),

    //restituisce la lista degli ultimi impianti visitati, oppure gli impianti filtrati rispetto a "filtroImpianto" con ricerca su tutto l'elenco
    filtLastPlants() {
      if (this.filtroImpianto == '')
        return this.$store.state.userLastPlants
      else
        return this.$store.state.userAllPlants.filter( (pl) => {
          if (this.filtroImpianto != '') {
            //filtro sul nome dell'impianto
            if ((pl.plantname.toLowerCase().includes(this.filtroImpianto.toLowerCase().trim())) ||
                (pl.address.city.toLowerCase().includes(this.filtroImpianto.toLowerCase().trim())) ||
                (pl.address.street.toLowerCase().includes(this.filtroImpianto.toLowerCase().trim())) ||
                (pl.address.prov.toLowerCase().includes(this.filtroImpianto.toLowerCase().trim()))) {
              return true;
            }
          } else {
            return true;
          }
        })
    },

    clienteImpianto() {
      let plant = this.$store.state.currentPlant;
      if (plant == null || plant.plant_users == null || plant.plant_users.length == 0) return null;

      let cli = plant.plant_users.filter(function(u) {
          return u.role == 'client';
      });
      console.log("cli=",cli);
      if (cli != null && cli.length == 0) return null;
      return cli[0];
    },
    delegati() {
      let plant = this.$store.state.currentPlant;
      if (plant == null || plant.plant_users == null || plant.plant_users.length == 0) return null;

      let deleg = plant.plant_users.filter(function(u) {
          return u.role == 'delegate';
      });
      console.log("deleg=",deleg);
      if (deleg != null && deleg.length == 0) return null;
      return deleg;
    },
    collaboratori() {
      let plant = this.$store.state.currentPlant;
      if (plant == null || plant.plant_users == null || plant.plant_users.length == 0) return null;

      let collab = plant.plant_users.filter(function(u) {
          return u.role == 'collab';
      });
      console.log("collab=",collab);
      if (collab != null && collab.length == 0) return null;
      return collab;
    },
    submitCodeDisabled() {
      if (this.codicePro == "") return true;
      if (this.updatingPro) return true;
      return this.codicePro.length != 16;
    },
    codeState() {
      if (this.codicePro.length == 0) return null;
      return this.codicePro.length == 16;
    },
    getUserAvatar() {
      return this.$store.getters.userName;
    },
    getUserRole() {
      console.log("USER ROLE",this.$store.getters.userRole);
      return this.$store.getters.userRole;
    },


    notificheAllPlants() {
      const allplants = this.$store.state.userAllPlants;
      const notifiche = [];

      if (allplants && allplants.length > 0) {
        for (const plant of allplants) {
          if (plant.controlunits) {
            for (const cu of plant.controlunits) {
              if (parseInt(cu.num_lamp_error) > 0) {
                notifiche.push({
                  type: "error",
                  cuid: cu.cuid,
                  cuname: cu.cudesc,
                  plant,
                  numerrors: cu.num_lamp_error
                });
              }
              if (parseInt(cu.num_lamp_found) === 0) {
                notifiche.push({
                  type: "warning",
                  cuid: cu.cuid,
                  cuname: cu.cudesc,
                  plant,
                  message: "Nessuna lampada trovata"
                });
              }
            }
          }
        }
      }
      return notifiche;
    },

    bellNotifiche() {
      return this.notificheAllPlants.length;
        // const allplants = this.$store.state.userAllPlants;
        // var numErrors=0;
        // this.notificheAllPlants=[];
        // console.log("Notifiche per all plants", allplants);
        // if(allplants!=null && allplants.length>0)
        // {
        //   for (var i=0; i<allplants.length;i++)
        //   {
        //       var plant=allplants[i];
        //       if(plant.controlunits)
        //       {
        //         for(var k=0; k<plant.controlunits.length; k++)
        //           {
        //             var notifica={};
        //             //console.log("notifiche control unit",plant);
        //             if(parseInt(plant.controlunits[k].num_lamp_error)>0)
        //             {
        //               notifica.type="error";
        //               notifica.cuid=plant.controlunits[k].cuid;
        //               notifica.cuname=plant.controlunits[k].cudesc;
        //               notifica.plant=plant;
        //               notifica.numerrors=plant.controlunits[k].num_lamp_error;
        //               this.notificheAllPlants.push(notifica);
        //               numErrors++;
        //             }
        //             if(parseInt(plant.controlunits[k].num_lamp_found)==0)
        //             {
        //               notifica.type="warning";
        //               notifica.cuid=plant.controlunits[k].cuid;
        //               notifica.plant=plant;
        //               this.notificheAllPlants.push(notifica);
        //               numErrors++;
        //             }
        //           }
        //       }
        //   }
        // }
        // console.log("Notifiche errori all plants", this.notificheAllPlants);
        // return numErrors;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    isPro() {
        const plant = this.$store.state.currentPlant;
        if (plant == null) return false;
        return (plant.plant_type == 'pro' || plant.plant_type == 'premium');
    },
    plantDetails() {
        const plant = this.$store.state.currentPlant;
        if (plant == null) return null;
        if (plant.id != this.plantId) return null;
        return plant;
    },
    lastPlantName() {
      console.log("ROUTE", this.$route,this.$store.state.userLastPlants);
      if(this.$store.state.currentPlant!=null)
        return this.$store.state.currentPlant.plantname;
    },
    lastPlantAddress() {
      if(this.$store.state.currentPlant!=null)
      {
        const addr = this.$store.state.currentPlant.address;
        return (
          addr.street +
          " " +
          addr.housenumber +
          " - " +
          addr.city +
          " (" +
          addr.prov +
          ")"
        );
      }
    },
    validation_userName() {
            if(this.saveUser==true) return this.userName.length > 0
         },
    validation_userSurname() {
            if(this.saveUser==true) return this.userSurname.length > 0
        },
    validation_userbusinessName() {
            if(this.saveUser==true) return this.userbusinessName.length > 0
        },
    validation_userStreet() {
            if(this.saveUser==true) return this.userStreet.length > 0
        },
    validation_userPiva() {
            if(this.saveUser==true) return this.userPiva.length > 7 && this.userPiva.length < 13
        },
    validation_userPhone() {
            if(this.saveUser==true) return this.userPhone.length > 0
        },
    validation_userNumber() {
            if(this.saveUser==true) return this.userNumber.length > 0
        },
    validation_userCity() {
            if(this.saveUser==true) return this.userCity.length > 0
        },
    validation_userCap() {
            if(this.saveUser==true) return this.userCap.length > 0
        },
    validation_userProv() {
            if(this.saveUser==true) return this.userProv.length > 0
        },
    validation_userCountry() {
            if(this.saveUser==true) return this.userCapCountry.length > 0
        },
    validation_plantName() {
      if (this.saveSubmit == true) return this.plantName.length > 0;
    },
    validation_plantStreet() {
      if (this.saveSubmit == true) return this.plantStreet.length > 0;
    },
    validation_plantNumber() {
      if (this.saveSubmit == true) return this.plantNumber.length > 0 ;
    },
    validation_plantCity() {
      if (this.saveSubmit == true) return this.plantCity.length > 0;
    },
    validation_plantCap() {
      if (this.saveSubmit == true) return this.plantCap.length > 0;
    },
    validation_plantProv() {
      if (this.saveSubmit == true) return this.plantProv.length > 0;
    },
    validation_plantCountry() {
      if (this.saveSubmit == true) return this.plantCountry.length > 0;
    }
  },
  updated() {
    //console.log("Updated", this.$route.params.pid);
    //this.selectPlant(this.$route.params.pid,0);
  },
  watch: {

    loading(val) {
      if (val== false && (this.$store.state.userAllPlants==null || this.$store.state.userAllPlants.length=== 0))
      {
        if (this.$store.state.user.validation == 'suspended' || this.$store.state.user.validation == 'disabled') {
          console.log("MainContainer - Utente sospeso");
          this.$store.state.userLastPlants = [];
          return;
        }
        if (this.$store.state.user.usertype != 'admin') {
          console.log("carico tutti gli impianti per calcolare le notifiche di errore", this.$store.state.user.usertype)
          this.$store.dispatch('loadAllPlantsPost',  this.$store.getters.userId);
          console.log("current route", this.$router.currentRoute.fullPath);
        }
      }
    },
    commandResponse(val) {
      console.log("updated commandResponse: ", val);
      /*if (val.pending == false && val.command == 'upgradePlant') {
        this.updatingPro = false;
        if (val.response.error != null) {
          this.$bvModal.msgBoxOk('Si è verificato un errore:\n' + val.response.error, {
            title: 'Errore',
            okVariant: 'danger',
            centered: true
          })

        } else {
          console.log("Upgraded to PRO!");
          this.$store.state.currentPlant.plant_type = val.response.data.plant_type;
          this.$store.state.currentPlant.pro_code = this.codicePro;
          this.$bvModal.msgBoxOk("Complimenti!\nL'impianto è stato upgradato a PRO con successo!", {
            title: 'Upgrade completato con successo',
            okVariant: 'success',
            centered: true
          })
        }
      } */
    }
  },
  methods: {

    //memorizza la lingua scelta in $i18n.locale e in localStorage così da poterla ripristinare al prossimo accesso
    //aggiorna l'attributo lang del tag html per l'accessibilità
    saveLocale() {
      this.$i18n.locale = this.linguaSelected;
      localStorage.setItem('locale', this.$i18n.locale);
      document.documentElement.setAttribute('lang', this.$i18n.locale);
    },

    mostraSelezionaLingue() {
      console.log("lingue supportate: ", this.$i18n.messages);
      this.$bvModal.show("modal-language");
    },

    openPlant(plant)
    {
      let recPlants = this.$store.state.userLastPlants
      console.log("BEFORE",recPlants);
      for (var k=0;k<recPlants.length;k++)
      {
          if(recPlants[k].id==plant.id)
          {
              var index=k;
              console.log("INDEX",index);
          }
      }
      recPlants.splice(index,1)
      recPlants.unshift(plant)
      console.log("AFTER",recPlants);
      this.$store.state.userLastPlants = recPlants
      this.$bvModal.hide("modal-notifiche");
      router.push({ name: 'HomeImpianto', params: { pid: plant.id } })
    },
    mostraPaginaPlantUsers() {
      console.log("Goto Utenti Impianto", this.$store.state.currentPlant.id)
      this.$router.push({
        name: "UtentiImpianto",
        params: { plantId: this.$store.state.currentPlant.id }
      });
    },
    mostraPaginaSupporto() {
      console.log("Goto Supporto")
      this.$router.push({
        name: "Supporto",
      });
    },
    mostraPaginaGeneralPlant() {
      console.log("Goto Generali Impianto", this.$store.state.currentPlant.id)
      this.$router.push({
        name: "GeneraliImpianto",
        params: { plantId: this.$store.state.currentPlant.id }
      });
    },
    mostraPaginaUserProfile() {
      console.log("Goto Profilo", this.$store.getters.userId)
      this.$router.push({
        name: "UserProfile",
        params: { userId: this.$store.getters.userId, event:"simple"}
      });
    },
    mostraPaginaBecomeInstaller() {
      console.log("Goto Profilo", this.$store.getters.userId);
      console.log("All pants for this user",this.$store.state.userAllPlants);
      if (this.$store.state.userAllPlants=="no plants")
      {
        this.$router.push({
          name: "UserProfile",
          params: { userId: this.$store.getters.userId, event: "InstallerRegFirst"}
        });
      }
      else
      {
        this.$router.push({
          name: "UserProfile",
          params: { userId: this.$store.getters.userId, event: "InstallerReg"}
        });
      }

    },
    invitaCliente() {
      console.log("invito " + this.emailCliente);
      if (this.emailCliente == '' || this.emailCliente.indexOf('@') < 2) {
        this.$bvModal.msgBoxOk("Occorre specificare un indirizzo email valido", {
            title: 'Attenzione!',
            okVariant: 'danger',
            centered: true
          })
          return;
      }
      this.invitingCliente = true;
      this.$store.dispatch('invitaCliente',{plantId: this.plantDetails.id,plantName: this.plantDetails.plantname, email: this.emailCliente});

    },
    rimuoviDelegato(collabId, nome) {
      this.$bvModal.msgBoxConfirm("Rimuovere " + nome + " dai delegati di questo impianto?", {
        title: "Conferma",
        centered: true,
        okTitle: "Rimuovi",
        cancelTitle: "Annulla",
        okVariant: "danger"
      }).then(value => {
        if (value) {
          console.log("rimuovo delegato " + collabId);
          this.$store.dispatch('rimuoviDelegato',{plantId: this.plantDetails.id,userId: collabId});
        }
      });
    },
    invitaDelegato() {
      console.log("invito " + this.emailDelegato);
      if (this.emailDelegato == '' || this.emailDelegato.indexOf('@') < 2) {
        this.$bvModal.msgBoxOk("Occorre specificare un indirizzo email valido", {
            title: 'Attenzione!',
            okVariant: 'danger',
            centered: true
          })
          return;
      }
      this.invitingDelegato = true;
      this.$store.dispatch('invitaDelegato',{plantId: this.plantDetails.id,plantName: this.plantDetails.plantname, email: this.emailCollab});

    },
    rimuoviCollab(collabId, nome) {
      this.$bvModal.msgBoxConfirm("Rimuovere " + nome + " dai collaboratori di questo impianto?", {
        title: "Conferma",
        centered: true,
        okTitle: "Rimuovi",
        cancelTitle: "Annulla",
        okVariant: "danger"
      }).then(value => {
        if (value) {
          console.log("rimuovo collaboratore " + collabId);
          this.$store.dispatch('rimuoviCollaboratore',{plantId: this.plantDetails.id,userId: collabId});
        }
      });
    },
    invitaCollab() {
      console.log("invito " + this.emailCollab);
      if (this.emailCollab == '' || this.emailCollab.indexOf('@') < 2) {
        this.$bvModal.msgBoxOk("Occorre specificare un indirizzo email valido", {
            title: 'Attenzione!',
            okVariant: 'danger',
            centered: true
          })
          return;
      }
      this.invitingCollab = true;
      this.$store.dispatch('invitaCollaboratore',{plantId: this.plantDetails.id,plantName: this.plantDetails.plantname, email: this.emailCollab});

    },
    openSettings() {
      this.$bvModal.show("modal-settingsPlant");
    },
    openSettingsProfile() {
      this.$bvModal.show("modal-settingsProfile");
    },
    abilitaPro() {
      console.log("abilito pro..." + this.codicePro);
      if (this.codicePro.length != 16) {
        return;
      }
      this.updatingPro = true;

      this.$store.dispatch("abilitaPro",{code: this.codicePro, plantId: this.plantDetails.id});

    },
    chargeCurrentSettings() {
      this.plantId=this.$store.state.userLastPlants[0].id;
      this.plantName = this.$store.state.userLastPlants[0].plantname;
      this.plantStreet = this.$store.state.userLastPlants[0].address.street;
      this.plantNumber = this.$store.state.userLastPlants[0].address.housenumber;
      this.plantCity = this.$store.state.userLastPlants[0].address.city;
      this.plantCap = this.$store.state.userLastPlants[0].address.cap;
      this.plantProv = this.$store.state.userLastPlants[0].address.prov;
      this.plantCountry = this.$store.state.userLastPlants[0].address.country;
      console.log("CARICATI",this.$store.state.userLastPlants[0]);
    },
    chargeCurrentUserSettings() {
      this.userName=this.$store.state.user.name;
      this.userSurname=this.$store.state.user.surname;
      this.userbusinessName=this.$store.state.user.businessname;
      this.userPhone=this.$store.state.user.phone;
      this.userPiva=this.$store.state.user.piva;
      this.userStreet=this.$store.state.user.street;
      this.userNumber=this.$store.state.user.housenumber;
      this.userCap=this.$store.state.user.cap;
      this.userProv=this.$store.state.user.prov;
      this.userCity=this.$store.state.user.city;
      this.chk_marketing=this.$store.state.user.marketing;
      this.chk_profiling=this.$store.state.user.profiling;
      this.chk_thirdParts=this.$store.state.user.thirdParts;
    },
    mostraModalImpianti() {
      console.log("mostro modal impianti");
      this.$bvModal.show("modal-lastPlants");
    },
    mostraModalNotifiche() {
      console.log("mostro modal notifiche", this.notificheAllPlants);
      this.$bvModal.show("modal-notifiche");
    },
    mostraTutti() {
      this.$bvModal.hide("modal-lastPlants");
      if (this.$store.getters.userType == 'admin') {
        this.$store.state.currentPlant = null;
        this.$store.state.userLastPlants = [];
        this.$router.push({
          name: "NTOHome"
        });

      } else {
        this.$router.push({
          name: "AllPlants",
          params: { userId: this.$store.getters.userId }
        });
      }

    },
    mostraMappaAdmin() {
      if (this.$store.getters.userType != 'admin') return;
      console.log("currentPlant:",this.$store.state.currentPlant);
      let installer = this.$store.state.currentPlant.plant_users.find((u) => {
        return u.role == "installer";
      });
      if (installer == null) return;
      this.$bvModal.hide("modal-lastPlants");
      this.$router.push({
          name: "AllPlants",
          params: { userId: installer.userid, installerId: installer.userid, adminMode: true }
        });
    },
    // showProfile() {
    //   this.$bvModal.show("modal-language");
    // },
    logout() {
      console.log("logout!");
      Auth.signOut().then( () => {
        this.$store.commit("setLoggedUser", null);
        this.$router.push({ name: "Login" });
      });
    },
    about() {
      this.$bvModal.show("modal-about");
    },
    selectPlant(plantId, index) {
      this.$bvModal.hide("modal-lastPlants");
      console.log("selezionato impianto " + plantId + ", index=" + index);
      // if (index == 0) return;
      this.$store.commit("selectPlant", {
        plant_id: plantId,
        plant_index: index
      });
      //this.$router.push("/plant/"+plantId);
    },
    handleOk() {
    this.saveSubmit = true;
      // Trigger submit handler
      this.updatePlant();
    },
    updatePlant() {
      var searchPlace = "";

      if (
        this.plantName != "" &&
        this.plantStreet != "" &&
        this.plantNumber != "" &&
        this.plantCity != "" &&
        this.plantCap != "" &&
        this.plantProv != "" &&
        this.plantCountry != ""
      ) {
        //Define var place
        var place =
          this.plantStreet +
          " " +
          this.plantNumber +
          " " +
          this.plantCity +
          " " +
          this.plantProv +
          " " +
          this.plantCountry;

        searchPlace =
          this.apiUrl + place + ".json?access_token=" + this.accessToken;

        console.log("SEARCH",searchPlace);
        //Get coordinates lat and long
        axios.get(searchPlace).then(response => {
          var longitude = response.data.features[0].center[0];
          var latitude = response.data.features[0].center[1];
          console.log("Coordinate-lat,long", latitude, longitude);
          this.$store.dispatch("dbUpdatePlant", {
            id: this.plantId,
            name: this.plantName,
            street: this.plantStreet,
            number: this.plantNumber,
            city: this.plantCity,
            cap: this.plantCap,
            prov: this.plantProv,
            country: this.plantCountry,
            lat: latitude,
            long: longitude
          });
        });

        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    }
  }
};
</script>

<style lang="scss">
#modal-lastPlants > div.modal-dialog {
  margin-left: 240px !important;
  margin-top: 10px !important;

  .modal-content {
    background-color: #f4f4f4;
  }
  .modal-header {
    background-color: #fff;
  }
}

#modal-notifiche > div.modal-dialog {
  margin-right: 150px !important;
  margin-top: 70px !important;

  .modal-content {
    background-color: #f4f4f4;
  }
  .modal-header {
    background-color: #fff;
  }
}
@media screen and (min-width: 767px) {
  #settings-icon {
    display:none;
  }
}



@media screen and (max-width: 767px) {
  #modal-lastPlants > div.modal-dialog {
    margin-left: 8px !important;
  }
  #settings-item {
    text-align: left;
    margin-top: 0px !important;
    padding: 0px !important;
  }

  #settings-icon-img {
    width: 36px;
    height: 24px;
    padding-right: 12px !important;
  }

  #settings-icon {
    display: none;
  }

  #bell{
    margin-top: 0px !important;
    padding: 0px !important;
  }

}

@media screen and (max-width: 320px) {

  #settings-item button {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

}

@media screen and (max-width: 1000px) {
  #avatar-name {
    display:none;
  }
  #mainNavBar.navbar  {
    ul.navbar-nav.bell-item {
        display: block;
        position: absolute;
        top: 12px;
        right: 100px;
    }
  }
  #settings-text {
    display:none;
  }
}

#modal-profile > div.modal-dialog {
  margin-right: 10px !important;
  margin-top: 100px !important;

  .modal-content {
    background-color: #f4f4f4;
  }
  .modal-header {
    background-color: #fff;
  }
}

.searchButton {
  color: #000000;
  font-size: 26px;
  margin-right: 10px;
}

.plantList {
  display: block;
  color: #000;
  background-color: #fff;
  margin-top: 0.5rem;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
}

.plantList:hover {
  color: black;
  background-color: #d2e7ef;
}


.selected {
  background-color: #e2f7ff;
  border-color: #e2f7ff;
}

.bell-item i {
  display: inline-block;
  color: #fff;
  font-size: 26px;
  margin-top: 8px;
}

.bell-item span.badge {
  vertical-align: top;
  margin-top: 10%;
}

li.nav-item {
  //margin-top: 14px;
  list-style: none;
}

.modal-xl {
  max-width: 95%;
}

#modal-settingsPlant .modal-content {
  min-height: 600px;
}

.notifiche{
    border-top: none;
    border-bottom: none;
    border-right: none;
    border-left: solid 3px;
    border-radius: 0em;
    border-color: #FEBF04;
    margin-bottom: 4px;
}
.notificaerror{
    border-color: #F03040;
}
.texterror{
    color: #F03040;
}
.textwarning{
    color:#FEBF04;
}
.linkplant{
  padding: 0px;
  vertical-align: 0px;
  font-weight: 600;
}
</style>
